import React from "react";
import { Grid, Container } from "@mui/material";
import SocialBlock from "../../components/social-block/social-block";
import "./info.css";
import { motion } from "framer-motion";

const Info = () => {
  const STAGGER = 0.07;

  return (
    <motion.div
      className="info-container"
      initial={{
        opacity: 0,
        y: 10,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      exit={{
        opacity: 0,
        y: -10,
      }}
      transition={{ duration: 0.3 }}
    >
      <Container>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          className="info-grid"
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            alignItems="center"
            justifyContent="center"
          >
            <div className="hero-block">
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: 1 * STAGGER }}
              >
                <img
                  className="hero-portrait"
                  src="images/2a5cd8ccea57ab6f216aaee4f4848698.jpg"
                  alt="Chris McGee"
                />
              </motion.div>
              <div className="hero-text">
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 2 * STAGGER }}
                >
                  <h2>Hi, I'm Chris</h2>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 3 * STAGGER }}
                >
                  <p>
                    Currently I work as a UX Engineer for Google on the Syntec
                    team.
                  </p>
                  <p>
                    Prior to Google, I was an Engineering Manager at{" "}
                    <a className="std" href="https://penumbra.com" target="new">
                      Penumbra
                    </a>
                    , working with the Platform Team on the{" "}
                    <a
                      className="std"
                      href="https://realsystem.com"
                      target="new"
                    >
                      REAL® System
                    </a>{" "}
                    - a VR ortho rehab platform that allows providers, such as
                    physical therapists, occupational therapists, and speech
                    language pathologists, to customize therapy sessions for
                    high-acuity to high-functioning patients.
                  </p>
                  <p>
                    Prior to Penumbra, I wore a combination of hats that could
                    best be described as Lead Game Developer / Full-Stack
                    Engineer for{" "}
                    <a
                      className="std"
                      href="https://floathybrid.com"
                      target="new"
                    >
                      Float Hybrid Entertainment
                    </a>
                    ; designing and developing interactive experiences, hardware
                    prototypes, games, and software systems for some of the
                    worlds largest brands, including Nike/Jordan, Pepsi,
                    Microsoft, Luxottica, and others.
                  </p>
                  {/* <p>
                    Since the onset of COVID-19, I also helped launch{" "}
                    <a className="std" href="https://songaid.com" target="new">
                      SongAid™
                    </a>{" "}
                    which is a platform for generating revenue for social causes
                    through streaming music from online providers. SongAid™ is a{" "}
                    <a
                      className="std"
                      href="https://tracktribe.com"
                      target="new"
                    >
                      TrackTribe™
                    </a>{" "}
                    project.
                  </p> */}
                  <p>
                    Prior to Float, I spent a little over 16 years designing and
                    developing games in the AAA Console space for{" "}
                    <a
                      className="std"
                      href="https://www.starwars.com/games-apps"
                      target="new"
                    >
                      LucasArts
                    </a>
                    ,{" "}
                    <a className="std" href="https://www.ea.com/" target="new">
                      Electronic Arts
                    </a>
                    ,{" "}
                    <a
                      className="std"
                      href="http://doublefine.com/"
                      target="new"
                    >
                      Doublefine
                    </a>{" "}
                    and others. Starcraft Ghost™ is the greatest game to never
                    have shipped.
                  </p>
                  <p>
                    When not building software, or being a dad, or playing
                    Squash, I enjoy playing music in the San Francisco bay area
                    with several musical projects, most notably{" "}
                    <a
                      className="info"
                      href="http://jazzmafia.com"
                      target="new"
                    >
                      The Jazz Mafia
                    </a>
                    .
                  </p>
                  <SocialBlock />
                </motion.div>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    </motion.div>
  );
};

export default Info;
